// eslint-disable-next-line  @typescript-eslint/ban-ts-ignore
// @ts-ignore
import access from 'safe-access';
import { Period } from './types';

export const isRowValid = (sport: string, clip: Period): boolean => {
	let valid = false;
	const mandatoryFields: string[] = ['source.startTime', 'source.endTime', 'title'];

	if (sport.toLowerCase() !== 'f1') {
		if (sport.toLowerCase() !== 'cricket') {
			mandatoryFields.push('shortText');
		}
		mandatoryFields.push('startGameTime.position');
		mandatoryFields.push('startGameTime.segment');
		mandatoryFields.push('startGameTime.segmentId');
	}

	if (sport.toLowerCase() !== 'f1' && sport.toLowerCase() !== 'golf') {
		mandatoryFields.push('team.id');
	}

	valid = !mandatoryFields.find((field) => {
		return !access(clip, field);
	});

	return valid;
};
